module.exports = __webpack_public_path__ + "img/1_A.24f3b386.png";